export const BRILLIANCE_MEMBER_PRICE = 'Brilliance-MemberPrice'

export const BRILLIANCE_MEMBER_PRICE_EXCLUSIONS = 'Vue-MemberPriceExclusions'
